import { render, staticRenderFns } from "./UserPayments.vue?vue&type=template&id=3c987306&scoped=true"
import script from "./UserPayments.vue?vue&type=script&lang=js"
export * from "./UserPayments.vue?vue&type=script&lang=js"
import style0 from "./UserPayments.vue?vue&type=style&index=0&id=3c987306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c987306",
  null
  
)

export default component.exports